module.exports = __webpack_public_path__ + "static/media/9.01859d1a.jpg";